export function setClientes(state, clientes) {
    state.clientes = clientes;
}

export function setTotalClientes(state, total) {
    state.totalClientes = total;
}

export function setClienteSelec(state, cliente) {
    state.clienteSelec = cliente;
}

export function actListClientes(state, cliente) {
    if (cliente !== null) {
        const index = state.clientes.findIndex(r => r.id === cliente.id)
        if (index != -1) {
            state.clientes[index].nombre = cliente.nombre;
            state.clientes[index].tipoCliente = cliente.tipoCliente;
            state.clientes[index].apellidos = cliente.apellidos;
            state.clientes[index].telefono = cliente.telefono;  
            state.clientes[index].email = cliente.email;  
            state.clientes[index].documento = cliente.documento;  
            state.clientes[index].direccion = cliente.direccion;  
            state.clientes[index].agencia = cliente.agencia;
            state.clientes[index].comentarios = cliente.comentarios;  
        }
    }
  
}

export function actDeleteListClientes(state, id) {
    if (id != null) {
        const index = state.clientes.findIndex(r => r.id === id)
        if (index != -1) {
            state.clientes.splice(index, 1)
        }
    }
}


